import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import VidsUserDetail from './VidsUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyVidsUserDetail } from './companyVidsApi';

/**
 * Company Shoorah Videos → one employee's/member's viewing profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CVidsUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Video Profile | Shoorah</title>
      </Helmet>
      <VidsUserDetail
        fetcher={fetchCompanyVidsUserDetail}
        backPath={`/${slug}/shoorah-videos/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CVidsUserDetail;
